import React from 'react';
import Alert from '@mui/material/Alert';

export const NoPaymentAccountSubscriptionAlert: React.VoidFunctionComponent = () => (
  <Alert severity="info">Add a profile to begin your trial!</Alert>
);
